/* MENU CONTACTO AGIL */
// INICIALIZAR EL CHATBOT
const btnChatbot = document.querySelector('#chatbot-btn');
const collapseChatbotFull = document.querySelector('#collapseFullChatbot');
const statusChatbot = document.querySelectorAll('.status-chatbot');


// Online status chatbot
const chatbotStatus = (from, to, id, hour, day) => {
  // console.log(day)

  for (let i= 0; i < statusChatbot.length; i++) {
    if(day > 5){
      id[i].classList.add('d-none');
    } 
    else {
      if (hour < from || hour > to) {
        id[i].classList.add('d-none');
      }
      else{
        id[i].classList.remove('d-none');
      }
    }
  }
}

const getTime = () => {
  const fecha = new Date(); 
  const dia = fecha.getDay(); //local day
  const hora = fecha.getHours(); //local hours
  const minutos = fecha.getMinutes(); //local minutes

  if (minutos < 10) {
    const horaTexto = hora.toString() + '0' + minutos.toString();
    const horaValida = parseInt(horaTexto);
    // console.log(horaValida);
    chatbotStatus(730,1730,statusChatbot,horaValida,dia);
    // chatbotStatus(200,1000,statusChatbot,horaValida);
  } else {
    const horaTexto = hora.toString() + minutos.toString();
    const horaValida = parseInt(horaTexto);
    // console.log(horaValida);
    chatbotStatus(730,1730,statusChatbot,horaValida,dia);
    // chatbotStatus(200,1000,statusChatbot,horaValida);
  }

  // chatbotStatus(730,1730,statusChatbot,horaValida);
  // chatbotStatus(200,1000,statusChatbot,horaValida);
}
getTime();


audioPlay = (url) => {
  const audio = new Audio(url);
  audio.play();
}

notificationNumbers = (tiempo1=250, tiempo2=0) => {
  const msnItem = document.querySelector('.contador-msn');
  const msnItems = document.querySelectorAll('.contador-msn');

  const contenedorBtnChatbot = document.querySelector('#contendor-btn');

  setTimeout(() => {
    const contadorMsn = document.createElement('P');
    contadorMsn.textContent = '2';
    contadorMsn.classList.add('contador-msn');
    contenedorBtnChatbot.appendChild(contadorMsn);

    if (msnItem) {
      msnItems.forEach( (e) => {
        e.remove();
      });
    }
  }, tiempo1);
}


validatePathAudio = () => {
  let pathAudio = "/build/audio/notification-sound.mp3";
  audioPlay(pathAudio);
}

notificationAudios = (tiempo1=0, tiempo2=0) => {
  setTimeout(() => {
    validatePathAudio();
  }, tiempo1);
}

// COUNT GLOBAL FISRT CLICK ON BTN BOT
const countSoundsChatbot = (value=0) => {
  if (value < 1) {
    return 0;
  } else {
    notificationAudios(0);
    notificationNumbers(250);
  }
}   


// Animations
const bodyFull = document.querySelector('.body-chatbot-full');
const bodyFullInicio = document.querySelector('#content-inicio');
const animacionesChatbotIn = (element) => {
  element.classList.add('transition');
}

// SHOW HIDE EVENTS COLLAPSE CHATBOT SMALL
$('#collapseSmallChatbot').on('hide.bs.collapse', () => {
  countSoundsChatbot(0);
});

// SHOW HIDE EVENTS COLLAPSE CHATBOT FULL
$('#collapseFullChatbot').on('hide.bs.collapse', () => {
  countSoundsChatbot(0);


  if ((window.innerWidth < 767)){
    $('.head-chabot-full').removeClass('fixed');
  }
});

$('#collapseFullChatbot').on('show.bs.collapse', () => {
  clearTimeout(timeOutShowChatbotInitialAudio);
  clearTimeout(timeOutShowChatbotInitialNumbers);
  // clearTimeout(timeOutShowChatbotFull);
  countSoundsChatbot(1);
  animacionesChatbotIn(bodyFullInicio);

  if ((window.innerWidth < 767)){
    $('.head-chabot-full').addClass('fixed');
  } 

  window.addEventListener('resize', () => {
    if ((window.innerWidth < 767)){
      $('.head-chabot-full').addClass('fixed');
    }
    else{
      $('.head-chabot-full').removeClass('fixed');
    }
  });
});

// const openSmallChatbotWindowTimer = () => {
const openFullChatbotWindowTimer = () => {
  if (collapseChatbotFull.classList.contains('show')) {
    return;
  } else {
    $('#collapseFullChatbot').collapse('show');
  }
}

// Timeouts Begin Page
const timeOutShowChatbotInitialAudio = setTimeout(notificationAudios, 4750);
const timeOutShowChatbotInitialNumbers = setTimeout(notificationNumbers, 5000);
// const timeOutShowChatbotFull = setTimeout(openFullChatbotWindowTimer, 15000);

// const resetTimerResize = () => {
//   if(window.innerWidth < 991){
//     clearTimeout(timeOutShowChatbotFull);
//   }
// }
// resetTimerResize();


// TRANSITIONS
const transicionStepsChatbot = () => {
  const btnFullToBegin = document.querySelector('#step-full-to-small');

  const btnStepContentInicio = document.querySelector('#step-link-screen-01');
  const btnStepDefault = document.querySelector('#step-link-default');

  const contentInicio = document.querySelector('#content-inicio');
  const screen01 = document.querySelector('#screen-01');
  const bodyScreen01 = document.querySelector('.body-chatbot-full');
  
  const resetContent = () => {
    screen01.classList.add('d-none');
    bodyScreen01.classList.remove('step-screen-01');
    contentInicio.classList.remove('d-none');
  }

  // SMALL TO FULL
  btnChatbot.addEventListener('click', () => {
    btnChatbot.classList.add('d-none');
    $('#collapseSmallChatbot').collapse('hide');
    // countSoundsChatbot(2);
  })

  // FULL TO SMALL
  btnFullToBegin.addEventListener('click', () => {
    btnStepDefault.classList.add('d-none');
    btnChatbot.classList.remove('d-none');

    resetContent();
  })

  // TRANSITION STEP SCREEN 01
  btnStepContentInicio.addEventListener('click', () => {
    animacionesChatbotIn(screen01);
    countSoundsChatbot(1);

    contentInicio.classList.add('d-none');
    bodyScreen01.classList.add('step-screen-01');
    screen01.classList.remove('d-none');

    btnStepDefault.classList.remove('d-none');
  });

  // TRANSITION STEP DEFAULT
  btnStepDefault.addEventListener('click', () => {
    btnStepDefault.classList.add('d-none');

    animacionesChatbotIn(contentInicio);
    countSoundsChatbot(1);
    resetContent();
  });
}
transicionStepsChatbot();



